import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterUnreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-filter-unread-wireframe", __assign({}, transformedProps), children));
};
export default VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterUnreadWireframe;
